import React, { ReactNode, useState } from "react";
import { ChevronDown } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { cn } from "@/lib/utils";

interface NodeMoreOptionsProps {
  children: ReactNode;
}

export default function NodeMoreOptions({ children }: NodeMoreOptionsProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen} className="space-y-4">
      <CollapsibleTrigger asChild>
        <button
          type="button"
          className="flex w-full items-center justify-between rounded-md border border-dashed px-3 py-2 text-xs font-semibold uppercase tracking-wider text-primary hover:bg-primary/5"
        >
          {isOpen ? "Fewer options" : "More options"}
          <ChevronDown className={cn("h-4 w-4", isOpen && "rotate-180")} />
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent className="space-y-4">{children}</CollapsibleContent>
    </Collapsible>
  );
}
